import * as AWS from 'aws-sdk';
import { AppConfig } from '../config';

export const getApiUrl = (type, region = null) => {
    const sandboxApiTypes = ['user', 'project', 'group'];
    const sandboxKey = window?.localStorage?.getItem("SANDBOX_KEY");
    try {
        if (!region) {
            let user = window?.localStorage?.getItem('user');
            if (user) {
                user = JSON.parse(user);
                if (user.region) {
                    region = user.region;
                }
            }
        }
    } catch (error) {
    }

    if (!region) region = 'ap-northeast-2';

    let envSuffix = window.env === 'production' ? '' : ('-' + window.env);

    //production
    //development

    if (sandboxKey && sandboxApiTypes.includes(type)) {
        envSuffix = '-' + sandboxKey;
    }

    return `https://api-${region}-${type}-development.rayteams.com`;
    // return `https://api-${region}-${type}${envSuffix}.rayteams.com`;
}

export const getAuthApiUrl = (suffix = "") => {
    const sandboxKey = window?.localStorage?.getItem("SANDBOX_KEY");
    return !sandboxKey ?
        "https://auth.raysmiler.co.kr" + suffix : 
        "https://r69d1vle4j.execute-api.ap-northeast-2.amazonaws.com/test" + suffix
};

export const rayTeamsClientDownloadURL = async () => {
    AWS.config.update({
        region: 'ap-northeast-2',
        accessKeyId: AppConfig.DYNAMO_DB_ACCESS_KEY,
        secretAccessKey: AppConfig.DYNAMO_DB_SECRET_KEY
    });

    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        KeyConditionExpression: '#name=:name and begins_with(#type,:v)',
        FilterExpression: 'is_active=:true',
        ExpressionAttributeNames: { '#name': 'name', '#type': 'type' },
        ExpressionAttributeValues: {
            ':name': 'RayLink',
            ':true': true,
            ':v': 'v:'
        }
    };

    const data = await dc.query(params).promise();

    return data.Items.sort((a, b) => {
        if (a.version > b.version) return -1;
        if (a.version < b.version) return 1;
        return 0;
    })[0].full_file.direct_link;
}

export const versionSort = (arr, nested = 'version', reverse = false) => {
    let result = arr;
    try {
        result = arr.sort((b, a) => a[nested].localeCompare(b[nested], undefined, { numeric: true }));
        if (reverse) {
            result = result.reverse();
        }
    } catch (error) {
        console.log('ERROR[versionSort]: ', error);
    }
    return result;
};

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
}


export const moveTo = (history, e, path) => {
    if (e) {
        e.preventDefault();
    }
    history.push(path);
}

export const getVersion = (version) => {
    const split = version?.split('.') || [];

    let converted = '';

    split.forEach((x, idx) => {
        if (idx <= 2)
            converted += x + (idx !== 2 ? '.' : '');
    })

    return 'v' + converted;
}
